import ky from "ky"
import { atom } from "jotai"
import { unwrap, loadable } from "jotai/utils"

import { debug } from "~/lib/logger.client"

import type { SessionResponse } from "~/api/session"

const d = debug.extend("atoms:session")

/**
 * Response from /api/session endpoint.
 */
export const sessionAtom = atom(async () => {
  try {
    d("Sending request to /api/session.")
    const res = await ky.get("/api/session").json<SessionResponse>()
    d("Received response from /api/session", { res })
    return res
  } catch (e) {
    d("Request to /api/session failed.", { e })
    console.error(`Request to /api/session failed.`, e)
    return { customer: null, sessionId: "failed" } satisfies SessionResponse
  }
})

/**
 * Response from /api/session endpoint (unwrapped).
 */
export const sessionUnwrappedAtom = unwrap(sessionAtom, prev => prev ?? null)

/**
 * Response from /api/session endpoint (loadable).
 */
export const sessionLoadableAtom = loadable(sessionAtom)

/**
 * True if the session has resolved.
 */
export const sessionResolvedAtom = atom(get => {
  return !!get(sessionUnwrappedAtom)
})

/**
 * Customer from session.
 */
export const sessionCustomerAtom = atom(get => {
  const session = get(sessionUnwrappedAtom)
  return session?.customer ?? null
})

/**
 * Session ID from session.
 */
export const sessionIdAtom = atom(get => {
  const session = get(sessionUnwrappedAtom)
  return session?.sessionId ?? null
})
